<template>
  <div class="sidebar-container">
    <aside
      class="main-sidebar sidebar-dark-primary elevation-4 text-xs bg-sos-blue"
    >
      <!-- Brand Logo -->
      <a
        data-widget="pushmenu"
        href="#"
        role="button"
        class="brand-link"
        style="display: block; text-align: center"
      >
        <img
          :src="
            isSosUser || !empresa || !empresa.logo
              ? `/img/sos_logos/Logo_sos_contingencias.jpg`
              : `${$parent.uri_docs}${empresa.logo}`
          "
          :alt="isSosUser || !empresa ? `Gerenciamiento de Flota` : empresa.razon_social"
          class="brand-image img-circle elevation-2"
          style="opacity: 0.8; display: inline-block"
        />
        <br>

        <span class="brand-text app-brand-name" style="color: #ffffff;font-size: 1.5rem;">
          <strong>Movi <span class="highlight">7/24</span></strong>
        </span>
      </a>

      <!-- Sidebar -->
      <div id="sidebar" class="sidebar">
        <!-- SidebarSearch Form -->
        <div class="form-inline">
          <div class="input-group mt-2">
            <input
              class="form-control form-control-sidebar"
              type="search"
              placeholder="Buscar"
              aria-label="Search"
              v-model="filtro"
            />
            <div class="input-group-append">
              <button class="btn btn-sidebar">
                <i class="fas fa-search fa-fw"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul
            class="nav nav-pills nav-sidebar flex-column nav-compact"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <li class="nav-item" v-for="menu in filterMenu" :key="menu.id">
              <a href="#" class="nav-link">
                <i class="nav-icon" :class="menu.icono"></i>
                <p>
                  {{ menu.nombre }}
                  <i class="right fas fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview pl-2" v-if="menu.nivel2.length > 0">
                <li
                  class="nav-item"
                  v-for="nivel2 in menu.nivel2"
                  :key="nivel2.id"
                >
                  <router-link
                    :to="nivel2.ruta"
                    class="nav-link"
                    :class="
                      $route.fullPath == nivel2.ruta
                        ? 'bg-support text-white'
                        : ''
                    "
                  >
                    <i class="nav-icon" :class="nivel2.icono"></i>
                    <p>{{ nivel2.nombre }}</p>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
     <div class="sidebar-footer d-flex justify-content-between align-items-center p-2">
      <div class="brand-link">
        <a href="https://soscontingencias.com.co/" target="_blank">
          <img
            src="/img/sos_logos/logo_negativo.png"
            alt="SOS Contingencias"
            style="width: 65px"
          />
        </a>
      </div>
      <div class="brand-link" style="border-bottom: none;">
        <img
          src="/img/sos_logos/Logo-Support-7-24-Negativo.png"
          alt="Support 7/24"
          style="width: 65px;"
        />
      </div>
    </div>
    </aside>
  </div>
</template>

<script>
export default {
  name: "NavBarLeft",

  data() {
    return {
      filtro: "",
    };
  },

  computed: {
    empresa() {
    const user = this.$store.getters.getUser;
    return user && user.empresa ? user.empresa : null;
  },
    isSosUser() {
      const user = this.$store.getters.getUser;
      return user && user.id === 78;
    },
    filterMenu() {
      if (this.$store.state.menus) {
        const empresaId = this.$store.getters.getUser && this.$store.getters.getUser.empresa_id;
        const esLima = Number(empresaId) === 34;
        return this.$store.state.menus
          .map((res1) => {
            const nuevosNiveles2 = res1.nivel2
              .map((res2) => {
                if (!esLima && res2.permiso === "seguridad.agrupacionUsuarios.index") {
                  return null;
                }
                const nMenu = res2.nombre.toString().toLowerCase();
                const search = this.filtro.toLowerCase();
                return nMenu.includes(search) ? res2 : null;
              })
              .filter(Boolean); // Filtra los elementos nulos

            return nuevosNiveles2.length > 0
              ? { ...res1, nivel2: nuevosNiveles2 }
              : null;
          })
          .filter(Boolean); // Filtra los elementos nulos
      } else {
        return this.$store.state.menus;
      }
    },
  },
};
</script>

